// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Production20 from './Production20.tsx';
import Production20Filled from './Production20Filled.tsx';
import Production20CircleFilled from './Production20CircleFilled.tsx';
import Production24 from './Production24.tsx';
import Production24Filled from './Production24Filled.tsx';
import Production24CircleFilled from './Production24CircleFilled.tsx';
import Production40 from './Production40.tsx';
import Production40Filled from './Production40Filled.tsx';
import Production48 from './Production48.tsx';
import Production48Filled from './Production48Filled.tsx';

type ProductionProps = {
    variation:
        | '20'
        | '20Filled'
        | '20CircleFilled'
        | '24'
        | '24Filled'
        | '24CircleFilled'
        | '40'
        | '40Filled'
        | '48'
        | '48Filled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Production20,
    Production20Filled,
    Production20CircleFilled,
    Production24,
    Production24Filled,
    Production24CircleFilled,
    Production40,
    Production40Filled,
    Production48,
    Production48Filled,
};

const Production: FC<ProductionProps> = ({ variation, ...props }) => {
    const variationKey = `Production${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Production" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Production;
